<template>
  <!-- File upload / attachement -->
  <div class="file-upload">
    <form :action="uploadURL" enctype="multipart/form-data" method="post" target="upload-target">
      <input type="file" class="clickable" name="file"><br/>
      <button class="clickable">
        <span class="fa fa-fw fa-arrow-up"></span>
        <input type="submit" class="clickable" value="Upload">
      </button>
    </form>
    <iframe @load="iframeLoaded" name="upload-target" style="display:none;"></iframe>
  </div>
</template>

<script type="text/javascript">
export default {

  computed: {

    infobit () {
      return this.$store.state.detailPanel.infobit
    },

    uploadURL () {
      return '/infobits/infobit/' + this.infobit.id + '/file'
    }
  },

  methods: {
    iframeLoaded () {
      var isFileUpload = window.frames['upload-target'].document.getElementsByTagName('pre').length
      if (isFileUpload) {
        this.$store.dispatch('refreshInfobit')
      }
    }
  }
}
</script>

<style>
.file-upload button {
  margin-top: 0.5em;
}
</style>



// WEBPACK FOOTER //
// file-upload.vue?53f96e7b